//@ts-nocheck
import { getIndicesDetails } from "./indicesDetailPageApiCall";
const DB_NAME = "ChartsDataDB";
const STORE_NAME = "ScripCodeStore";
const LAST_FETCH_STORE = "LastFetchStore";
const LOCAL_KEY = "scripCodeMapCautinary";
const LAST_FETCH_DATE_KEY = "lastFetchDate";
const scripCodeMapCautinary = new Map();
const openDB = () => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, 1);
        request.onupgradeneeded = () => {
            const db = request.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: "key" });
            }
            if (!db.objectStoreNames.contains(LAST_FETCH_STORE)) {
                db.createObjectStore(LAST_FETCH_STORE, { keyPath: "key" });
            }
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
};
const saveToStore = async (storeName, key, value) => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, "readwrite");
        const store = tx.objectStore(storeName);
        store.put({ key, value });
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
};
const loadFromStore = async (storeName, key) => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, "readonly");
        const store = tx.objectStore(storeName);
        const request = store.get(key);
        request.onsuccess = () => {
            if (request.result) {
                resolve(request.result.value);
            }
            else {
                resolve(undefined);
            }
        };
        request.onerror = () => reject(request.error);
    });
};
const saveScripCodeMap = async (map, key) => {
    const obj = Object.fromEntries(map);
    await saveToStore(STORE_NAME, key, obj);
};
const loadScripCodeMap = async (key) => {
    const obj = await loadFromStore(STORE_NAME, key);
    if (!obj)
        return new Map();
    return new Map(Object.entries(obj));
};
export const updateScripCodeFlag = async (key, scripCode, flag) => {
    const map = await loadScripCodeMap(key);
    // Only update if scripCode already exists
    if (map.has(scripCode)) {
        map.set(scripCode, flag);
        await saveScripCodeMap(map, key);
    }
};
export const getScripCodeFlag = async (key, scripCode) => {
    const map = await loadScripCodeMap(key);
    return map.get(scripCode);
};
const isNewDay = async () => {
    const lastFetch = await loadFromStore(LAST_FETCH_STORE, LAST_FETCH_DATE_KEY);
    const today = new Date().toISOString().split("T")[0];
    return lastFetch !== today;
};
const saveTodayAsLastFetch = async () => {
    const today = new Date().toISOString().split("T")[0];
    await saveToStore(LAST_FETCH_STORE, LAST_FETCH_DATE_KEY, today);
};
export const isScripCodePresent = async (key, scripCode) => {
    const map = await loadScripCodeMap(key);
    return map.has(scripCode);
};
export const clearUserDataForCautionary = async () => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        try {
            const tx = db.transaction([STORE_NAME, LAST_FETCH_STORE], "readwrite");
            tx.objectStore(STORE_NAME).clear();
            tx.objectStore(LAST_FETCH_STORE).clear();
            tx.oncomplete = () => {
                scripCodeMapCautinary.clear(); // clear in-memory map too
                resolve();
            };
            tx.onerror = () => reject(tx.error);
        }
        catch (error) {
            reject(error);
        }
    });
};
export const fetchAndMergeIndicesOncePerDay = async () => {
    if (!(await isNewDay())) {
        return;
    }
    const results = [];
    try {
        const [sensex, nifty] = await Promise.all([
            getIndicesDetails("Sensex"),
            getIndicesDetails("Nifty"),
        ]);
        if (sensex === null || sensex === void 0 ? void 0 : sensex.Data)
            results.push(...sensex.Data);
        if (nifty === null || nifty === void 0 ? void 0 : nifty.Data)
            results.push(...nifty.Data);
        if (results.length === 0) {
            console.error("Failed to fetch both Nifty and Sensex data.");
            return;
        }
        scripCodeMapCautinary.clear();
        results.forEach((item) => {
            scripCodeMapCautinary.set(item.ScripCode, false);
        });
        await Promise.all([
            saveScripCodeMap(scripCodeMapCautinary, LOCAL_KEY),
            saveTodayAsLastFetch()
        ]);
    }
    catch (error) {
        console.error("Error while fetching indices data:", error);
    }
};
